import React from"react";// @ts-ignore-next-line
import styles from"./H2.module.scss";export var H2=function H2(_ref){var children=_ref.children;return/*#__PURE__*/React.createElement("h2",{className:styles.h2},children);};